import { render, staticRenderFns } from "./associationProfile.vue?vue&type=template&id=59dedfca&scoped=true"
import script from "./associationProfile.vue?vue&type=script&lang=js"
export * from "./associationProfile.vue?vue&type=script&lang=js"
import style0 from "./associationProfile.vue?vue&type=style&index=0&id=59dedfca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dedfca",
  null
  
)

export default component.exports